import type { FC } from "react";
import { useTranslation } from "react-i18next";

import { Button, Flex, Icon, IconButton, Text } from "@huub-web/ui";

import { contentHeaderStyle } from "./Header.css";

type HeaderProps = {
  back?: boolean;
  closable?: boolean;
  title?: string;
  padding?: boolean;
  onBackButtonClick?: () => void;
  onCloseButtonClick?: () => void;
};

/**
 * Header component for the side agent content panel
 */
export const Header: FC<HeaderProps> = ({
  padding = false,
  back,
  closable,
  title,
  onBackButtonClick,
  onCloseButtonClick,
}) => {
  const { t } = useTranslation();

  return (
    <Flex
      justify="space-between"
      gap="s"
      align="center"
      className={contentHeaderStyle({ padding })}
    >
      {back && (
        <Button
          leading={<Icon icon="chevronLeft" size="s2" />}
          size="s"
          onClick={onBackButtonClick}
          border="input"
          variant="opaque"
        >
          {t("sideAgentContent.header.backToHuub")}
        </Button>
      )}
      {title && <Text variant="bodyL">{title}</Text>}
      {closable && (
        <IconButton
          icon="close"
          size="xxs"
          rounded
          onClick={onCloseButtonClick}
        />
      )}
    </Flex>
  );
};
